import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { assertNonNullable } from '@y42/util/assert';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { BaseCellRendererComponent } from '../base-cell-renderer.component';

export interface StarredCellRendererParams {
  allowEdit?: boolean;
  showGroupOnly?: boolean;
  setStarred: (node: IRowNode) => void;
}

type IStarredCellRendererParams = ICellRendererParams & StarredCellRendererParams;

@UntilDestroy()
@Component({
  selector: 'y42-starred-cell-renderer',
  templateUrl: './starred-cell-renderer.component.html',
  styleUrls: ['./starred-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarredCellRendererComponent extends BaseCellRendererComponent<
  boolean,
  unknown,
  IStarredCellRendererParams
> {
  readonly state = connectState(this, {
    params: this.params$,
    starred: this.valueAsSingle$,
  });

  addStarred() {
    assertNonNullable(this.params);
    // for a better and instant display
    this.patchCellRendererParams({ value: !this.params.value });
    this.params.setStarred(this.params.node);
  }
}
